import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';

@observer
class ProductBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            product: null,
            addedToCart: false,
        };
    }

    loadProduct = async () => {
        const { productId } = this.props;
        if (!productId) return;
        const response = await util.fetchApi('/api/products/', { method: 'GET' }, { id: productId });
        const products = response?.data || [];
        if (Array.isArray(products) && products.length > 0) {
            this.setState({ product: products[0] });
        }
    }

    addToCart = async () => {
        const { stores } = this.props;
        const { userStore } = stores;
        const { product } = this.state;
        if (!product) return;
        const result = await userStore.addToCart({ product: product.id, qty: 1 });
        if (result) {
            this.setState({ addedToCart: true });
            setTimeout(() => this.setState({ addedToCart: false }), 2000);
        }
    }

    componentDidMount() {
        this.loadProduct();
    }

    render() {
        const { stores } = this.props;
        const { userStore } = stores;
        const { user = {} } = userStore;
        const { product, addedToCart } = this.state;

        if (!product) return null;

        const thumbnail = product.images?.[0]?.s3SmallLink || product.images?.[0]?.s3MediumLink;
        const price = product.price || product.priceOut;

        return (
            <div class='my-4 p-3 rounded-3 d-flex align-items-center bg-body-secondary border-start border-4 border-primary'>
                <div class='flex-fill'>
                    <div class='fw-bold mb-1 text-primary' style='font-size: 0.85em; text-transform: uppercase; letter-spacing: 0.05em;'>
                        Produkt
                    </div>
                    <span class='fw-bold text-body' style='font-size: 1.05em; line-height: 1.3;'>
                        {product.title || product.name}
                    </span>
                    {price > 0 && (
                        <div class='text-body-secondary mt-1' style='font-size: 0.95em;'>
                            Kr. {util.format(price, 2)}
                        </div>
                    )}
                    {user?.id && (
                        <div class='mt-2'>
                            {addedToCart ? (
                                <span class='text-success fw-bold' style='font-size: 0.9em;'>
                                    <i class='fa-solid fa-check me-1' />Lagt til!
                                </span>
                            ) : (
                                <button
                                    type='button'
                                    class='btn btn-sm btn-primary rounded-pill px-3'
                                    onClick={this.addToCart}
                                >
                                    <i class='fa-solid fa-cart-plus me-1' />
                                    Legg i handlekurv
                                </button>
                            )}
                        </div>
                    )}
                </div>
                {thumbnail && (
                    <div class='ms-3 flex-shrink-0'>
                        <img
                            src={thumbnail}
                            alt={product.title || product.name || ''}
                            class='rounded'
                            style='width: 80px; height: 80px; object-fit: cover;'
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default ProductBox;
